<div class="col-md-6 offset-md-3 mt-5">
  <div class="navbar-header" style="background-color: whitesmoke; height: 20%">
    <a class="" rel="category" href="#" title="Category Details"> </a>
  </div>
</div>

<div class="col-md-6 offset-md-3 mt-5">
  <div class="navbar-header">
    <a class="" rel="category" href="#" title="Category">
      <img
        class="responsive"
        style="width: 100%; height: auto"
        src="assets/images/header-1.jpg"
      />
    </a>
  </div>

  <section
    id="header"
    class="rounded"
    style="margin-top: 1%; background-color: white; text-align: center; text-emphasis-color: inherit;">
    <strong>ISKCON Indore</strong>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-12 col-centered" style="align-items: center; text-decoration: underline">
          <strong> DONATE ONLINE </strong>
        </div>
      </div>
    </div>
  </section>

  <div class="card" style="margin-top: 1%">

    <div class="card-body">
      <div *ngIf="!myDIV">
        <form [formGroup]="form" style="padding:20px 120px 0px 106px;" (ngSubmit)="Submit()">

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Nationality </mat-label>
              <input type="text" matInput placeholder="Enter Nationality" formControlName="nationality" autocomplete="off" required/>
              <mat-error *ngIf="form.controls['nationality'].hasError('required')">Nationality is required.</mat-error>
              <mat-error *ngIf="form.controls['nationality'].hasError('pattern')">Invalid Nationality</mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Donor Name </mat-label>
              <input type="text" matInput placeholder="Enter Donor Name" formControlName="donorName" autocomplete="off" required/>
              <mat-error *ngIf="form.controls['donorName'].hasError('required')">Donor Name is required.</mat-error>
              <mat-error *ngIf="form.controls['donorName'].hasError('pattern')">Invalid Donor Name</mat-error>
            </mat-form-field>
          </div>

            <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Email Id </mat-label>
              <input type="text" matInput placeholder="Enter Email Id " formControlName="emailId" autocomplete="off"/>
              <mat-error *ngIf="form.controls['emailId'].hasError('pattern')">Invalid Email ID</mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label> Mobile No. </mat-label>
              <input type="text" matInput placeholder="Enter Mobile No" formControlName="mobileNo" autocomplete="off" required/>
              <mat-error *ngIf="form.controls['mobileNo'].hasError('required')">Mobile No is required.</mat-error>
              <mat-error *ngIf="form.controls['mobileNo'].hasError('pattern')">Invalid Mobile No</mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Telephone No. </mat-label>
              <input type="text" maxlength="13" matInput placeholder="Enter Telephone No" formControlName="telephoneNo" autocomplete="off"/>
              <mat-error *ngIf="form.controls['telephoneNo'].hasError('pattern')">Invalid Telephone No.</mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label> Address </mat-label>
              <input type="text" matInput placeholder="Enter Address" formControlName="address" autocomplete="off" required/>
              <mat-error *ngIf="form.controls['address'].hasError('required')">Address is required.</mat-error>
              <!-- <mat-error *ngIf="form.controls['address'].hasError('pattern')">Invalid Address</mat-error> -->
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label> State </mat-label>
              <input type="text" matInput placeholder="Enter State" formControlName="state" autocomplete="off"/>
              <mat-error *ngIf="form.controls['state'].hasError('pattern')">Invalid State</mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label> City </mat-label>
              <input type="text" matInput placeholder="Enter City" formControlName="city" autocomplete="off" required/>
              <mat-error *ngIf="form.controls['city'].hasError('required')">City is required.</mat-error>
              <mat-error *ngIf="form.controls['city'].hasError('pattern')">Invalid City</mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Zip Code </mat-label>
              <input type="text" matInput placeholder="Enter ZipCode " formControlName="zipCode" autocomplete="off" />
              <mat-error *ngIf="form.controls['zipCode'].hasError('pattern')">Invalid ZIP Code</mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label> Country </mat-label>
              <input type="text" matInput placeholder="Enter Country " formControlName="country" autocomplete="off" required/>
              <mat-error *ngIf="form.controls['country'].hasError('required')">Country is required.</mat-error>
              <mat-error *ngIf="form.controls['country'].hasError('pattern')">Invalid Country </mat-error>
            </mat-form-field>
          </div>

         <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label> Donation Amount </mat-label>
              <input type="text" matInput placeholder="Enter Donation Amount " formControlName="donationAmount" autocomplete="off" required/>
              <mat-error *ngIf="form.controls['donationAmount'].hasError('required')">Donation Amount is required.</mat-error>
              <mat-error *ngIf="form.controls['donationAmount'].hasError('pattern')">Invalid Donation Amount </mat-error>
            </mat-form-field>
          </div> 

          <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label> PAN Card </mat-label>
                <input type="text" matInput placeholder="Enter PAN Card" formControlName="pan" autocomplete="off"/>
                <mat-error *ngIf="form.controls['pan'].hasError('pattern')">Invalid Pan Card No. </mat-error>
              </mat-form-field>
            <p style="color: red;"><b>NOTE : </b>Please Enter PAN no if Donation Amount is Rs 50,000/- or More</p>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label> Remarks </mat-label>
                <input type="text" matInput placeholder="Enter Remarks" formControlName="remark" autocomplete="off"/>
                </mat-form-field>
            </div>

            <div class="form-group">
              <label> Captcha</label>
              <input matInput  onpaste="return false;" onCopy="return false" onCut="return false" placeholder="Enter Captcha"
                 class="captchaFeild"  formControlName="captcha" autocomplete="off"
                minlength="6" maxlength="6"  onkeyup="this.value = this.value.toUpperCase();"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.captcha.errors }" style="border: 1px solid black;" required />
                <div *ngIf="submitted && f.captcha.errors " class="invalid-feedback">
                  <div *ngIf="f.captcha.errors.required">Captcha is required</div>
                  <div *ngIf="f.captcha.errors.incorrectcaptcha && (!f.captcha.errors.required)">Captcha is invalid </div>
                  <div *ngIf="f.captcha.errors.minlength && (!f.captcha.errors.required)">Captcha required of length {{f.captcha.errors.minlength.requiredLength}} and has length {{f.captcha.errors.minlength.actualLength}}  </div>
                </div>
             </div>
             <div id="capt">
                 <span onselectstart="return false" onpaste="return false;" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false">{{initialCap}}</span>
                 <span style="float: right; cursor: pointer;">
                         <i class="material-icons" (click)="Cap()">refresh</i>
                 </span>
            </div>



          <div class="form-group" style="
          display: flex;
          margin-top: 30px;
          justify-content: space-evenly;">
            <button
            #submitButton
            style="width: 129px;"
              class="btn btn-primary"
              (click)="onSubmit()"

            >
              <span
                *ngIf="loading"
                class="spinner-border spinner-border-sm mr-1"
              ></span>
              DONATE
            </button>
          </div>
          <div
            class="errBackButtonDiv"
            style="
              width: 129px !important;
              margin-top: 30px;
              margin-bottom: 20px;
            "
          >

          </div>
        </form>

      </div>
      <div>
        <form
          target="_top"
          #txnForm
          [formGroup]="tranxnForm"
          method="POST"
          action="{{ isgPay_url }}"
        >
          <input
            type="hidden"
            [value]="EncDataField"
            name="EncData"
            formControlName="EncData"
          />
          <input
            type="hidden"
            [value]="MerchantIdField"
            name="MerchantId"
            formControlName="MerchantId"
          />
          <input
            type="hidden"
            [value]="BankIdField"
            name="BankId"
            formControlName="BankId"
          />
          <input
            type="hidden"
            [value]="TerminalIdField"
            name="TerminalId"
            formControlName="TerminalId"
          />
          <input
            type="hidden"
            [value]="VersionField"
            name="Version"
            formControlName="Version"
          />
          <input
            type="hidden"
            [value]="TransactionId"
            name="OrderId"
            formControlName="TransactionId"
          />
        </form>
      </div>
      <div>
        <form   target="_top" #txnForm [formGroup]="tranxnForm" method="POST" action={{isgPay_url}}  >
          <input type="hidden" [value]="EncDataField"  name="EncData" formControlName="EncData">
          <input type="hidden" [value]="MerchantIdField" name="MerchantId" formControlName="MerchantId">
          <input type="hidden" [value]="BankIdField" name="BankId" formControlName="BankId">
          <input type="hidden" [value]="TerminalIdField" name="TerminalId" formControlName="TerminalId">
          <input type="hidden" [value]="VersionField" name="Version" formControlName="Version">
          <input type="hidden" [value]="TransactionId" name="OrderId" formControlName="TransactionId">



          </form>
        </div>
    </div>
  </div>
</div>
